import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';

// What a scanned invitation label shows: whose card it is, and where they are
// expected. Read without signing in, so it carries nothing about anyone else.
export default function GuestCardDesktop({ vm }) {
  const { loading, error, guest, fullName, event, functions } = vm;

  return (
    <div className="gcard-page">
      <div className="gcard">
        {loading ? <Spinner /> : error ? (
          <div className="gcard-error">{error}</div>
        ) : (
          <>
            <div className="gcard-event">{event?.EventName}</div>
            <h1 className="gcard-name">{fullName || guest?.CardName || 'Guest'}</h1>
            <div className="gcard-sub">
              {[guest?.City, guest?.MobileNumber, Number(guest?.ExpectedCount || 1) > 1 ? `${guest.ExpectedCount} persons` : '']
                .filter(Boolean).join(' · ')}
            </div>

            <div className="gcard-label">Invited to</div>
            {functions.length === 0 && <div className="muted">No functions on this invitation.</div>}
            <ul className="gcard-fns">
              {functions.map(f => (
                <li key={f.FunctionId}>
                  <strong>{f.FunctionName}</strong>
                  <span>{fmtDate(f.FunctionDate)}{f.StartTime ? ` · ${fmtTime(f.StartTime)}` : ''}</span>
                  {(f.Venue || f.VenueAddress) && (
                    <span className="muted">{[f.Venue, f.VenueAddress, f.City].filter(Boolean).join(', ')}</span>
                  )}
                  {f.GpsLocation && <a href={f.GpsLocation} target="_blank" rel="noreferrer">Open the map</a>}
                </li>
              ))}
            </ul>
            <div className="gcard-foot muted">Mehfil by Smartify</div>
          </>
        )}
      </div>
    </div>
  );
}
